async function updateCartClass() {
  const cartIcon = document.querySelector(".header__icon--cart");
  const cartIconBubble = document.querySelector("#cart-icon-bubble");
  await fetch(`${routes.cart_url}.js`)
    .then((response) => response.json())
    .then((data) => {
      data.item_count > 0
        ? cartIcon.classList.add("cart-active")
        : cartIcon.classList.remove("cart-active");

      if (data.item_count > 0) {
        cartIconBubble.classList.add("cart-active");
      } else {
        cartIconBubble.classList.remove("cart-active");
      }
    });
}
subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
  publish(PUB_SUB_EVENTS.cartUpdateCustom);
});
subscribe(PUB_SUB_EVENTS.cartUpdateCustom, () => updateCartClass());

const announcementBar = document.querySelector(".announcement-bar-section");

document.querySelectorAll(".header__icons .tooltip").forEach((child) => {
  child.addEventListener("mouseenter", function () {
    // Find the closest parent and increase its z-index
    announcementBar.style.zIndex = 991;
  });
  child.addEventListener("mouseleave", function () {
    // Reset the z-index after hovering out
    announcementBar.style.zIndex = 993;
  });
});

$(document).ready(function () {
  /* for desktop */
  let wishlistCount = $(".wishlist-desktop .uwl-count").text();
  // console.log(wishlistCount);
  if (wishlistCount == 0) {
    $(".header__icon--wishlist").removeClass("wishlist-has-val");
  } else {
    $(".header__icon--wishlist").addClass("wishlist-has-val");
  }

  let wishlistCountmob = $(".header_wishlist .mobile-only .uwl-count").text();
  // console.log(wishlistCountmob);
  if (wishlistCountmob == 0) {
    $(".header_wishlist .mobile-only").removeClass("wishlist-has-val");
  } else {
    $(".header_wishlist .mobile-only").addClass("wishlist-has-val");
  }

  $(document).on("click",".uwl-col-wishlist, .uwl-remove-wishlist", function () {
    var $this = $(this);
      setTimeout(function () {
        let wishlistCountmob = $(
          ".header_wishlist .mobile-only .uwl-count"
        ).text();

        if (wishlistCountmob == 0) {
          $(".header_wishlist .mobile-only").removeClass("wishlist-has-val");
        } else {
          $(".header_wishlist .mobile-only").addClass("wishlist-has-val");
        }

        let wishlistCount = $(".wishlist-desktop .uwl-count").text();

        //console.log(wishlistCount);

        if (wishlistCount == 0) {
          $(".header__icon--wishlist").removeClass("wishlist-has-val");
        } else {
          $(".header__icon--wishlist").addClass("wishlist-has-val");
        }

        if (wishlistCount == 1 && $this.hasClass("uwl-remove-wishlist")) {
          location.reload();
        }
      }, 300);
    }
  );
  /* end desktop */
});